module.exports = __webpack_public_path__ + "img/about-us-banner.964f9dca.jpg";